import NotFoundPage from './NotFoundPage.component';

export default NotFoundPage;
